module.exports = __webpack_public_path__ + "img/tile-keyframes_jp.2de67ca.jpg";